export const POINTS_LAYER_ID = 'droneImagesPointsLayer';
export const FOOTPRINTS_LAYER_ID = 'droneImagesFootprintsLayer';
export const LAYER_NAME = 'Drone Images';
export const SIDEBAR_ID = 'droneImagesSettings';

export const COLOR_CHANGE_DEBOUNCE_TIME = 300;

// Min zoom level to show points (below this, layer is hidden)
export const MIN_ZOOM_FOR_POINTS = 15;

// Z-index offset for points layer (rendered above footprints)
export const POINTS_LAYER_Z_INDEX_OFFSET = 1;

// Default colors
export const DEFAULT_POINT_COLOR = { r: 0, g: 150, b: 255, a: 1 };
export const DEFAULT_FOOTPRINT_COLOR = { r: 255, g: 200, b: 0, a: 0.6 };
